module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section03_01_beach-photo-b42948e98d12feeae51ed9a53e61e9a3.jpg";